/**
 * myProfileApi.js
 * ----------------
 * API client for Employee Self-Service My Profile screen.
 * Connects to /self-service/profile/me (FastAPI backend).
 */
import api from '../../../../api/client';

export const myProfileApi = {
  getProfile: async () => {
    try {
      const response = await api.get('/self-service/profile/me');
      return response.data; // { data: { personal: {...}, official: {...}, family: [], qualifications: [], skills: [] } }
    } catch (err) {
      console.warn('Failed to fetch employee profile:', err);
      throw err;
    }
  },

  updateProfile: async (payload) => {
    try {
      const response = await api.put('/self-service/profile/me', payload);
      return response.data;
    } catch (err) {
      console.warn('Failed to update employee profile:', err);
      throw err;
    }
  },
};
